import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    formatterDateToUTC
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const projectDrawOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "工程项目名称",
            prop: "name",
            type: 'select',
            span: 13,
            search: true,
            placeholder: '请选择客户端类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData: DIC.TAGS_CLIENT_TYPE,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择客户端类型"
            }],
        },
        {
            label: "关联服务商",
            prop: "company",
            type: 'input',
            span: 13,
            search: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入标签名称"
            }],
        },
        {
            label: "服务抽成规则",
            prop: "percentageNum",
            type: 'input',
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "工程师",
        //     prop: "name",
        //     type: 'select',
        //     formsolt:true,
        //     hide:true,
        // },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            formatter: function (row, value, label, column) {
                return formatterDateToUTC(row.createTime * 1)
            },
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};